// extracted by mini-css-extract-plugin
module.exports = {"link":"Row_link__bRdrJ","row":"Row_row__2KB0G","cell":"Row_cell__L4sVE","value":"Row_value__7207G","header":"Row_header__KwA6I"};